import { render, staticRenderFns } from "./confermeOrdini.html?vue&type=template&id=5b9f1e26&scoped=true&"
import script from "./ConfermeOrdini.vue?vue&type=script&lang=js&"
export * from "./ConfermeOrdini.vue?vue&type=script&lang=js&"
import style0 from "./ConfermeOrdini.vue?vue&type=style&index=0&id=5b9f1e26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9f1e26",
  null
  
)

export default component.exports